import { announcementService } from '@moal/api'
import {
  AnnouncementServerToClientEvents,
  AnnouncementViewModel
} from '@moal/types'
import { useContext, useEffect, useReducer } from 'react'
import { Socket } from 'socket.io-client'
import { SocketContext } from '../../context/socketContext'
import {
  initialState,
  reducer
} from '../../reducers/announcementsProviderReducer'
import { PRODUCT_CODE } from '../../utils/ENV'

export default function AnnouncementProvider({ limit, children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { announcementsSocket: socket } = useContext<{
    announcementsSocket: Socket<AnnouncementServerToClientEvents>
  }>(SocketContext)

  useEffect(() => {
    if (!socket) return
    socket.on('POST_ANNOUNCEMENT', handlePostAnnouncement)
    socket.on('EDIT_ANNOUNCEMENT', handlePutAnnouncement)
    socket.on('DELETE_ANNOUNCEMENT', handleDeleteAnnouncement)
    socket.on('READ_ANNOUNCEMENT', handleReadAnnouncement)
    socket.on('READ_ALL_ANNOUNCEMENTS', handleReadAllAnnouncements)
    return () => {
      socket.off('POST_ANNOUNCEMENT', handlePostAnnouncement)
      socket.off('EDIT_ANNOUNCEMENT', handlePutAnnouncement)
      socket.off('DELETE_ANNOUNCEMENT', handleDeleteAnnouncement)
      socket.off('READ_ANNOUNCEMENT', handleReadAnnouncement)
      socket.off('READ_ALL_ANNOUNCEMENTS', handleReadAllAnnouncements)
    }
  }, [socket])

  useEffect(() => {
    dispatch({ type: 'LOADING' })
    fetchAnnouncements()
  }, [])

  const fetchAnnouncements = async () => {
    if (!state.hasMore) return
    try {
      const response = await announcementService.getAll(
        limit,
        state.loadMore,
        PRODUCT_CODE
      )

      dispatch({
        type: 'FETCH_ANNOUNCEMENT_EVENTS',
        payload: response.data.announcements
      })
    } catch (error) {
      dispatch({ type: 'ERROR', payload: 'Error fetching announcements.' })
    }
  }

  const markRead = async (announcement: AnnouncementViewModel) => {
    try {
      await announcementService.markAsRead(announcement._id)
    } catch {
      console.error('Error marking announcement as read')
    }
  }

  const handlePostAnnouncement = (data: AnnouncementViewModel) => {
    dispatch({ type: 'ANNOUNCEMENT_POST', payload: data })
  }

  const handlePutAnnouncement = (data: AnnouncementViewModel) => {
    dispatch({ type: 'ANNOUNCEMENT_PUT', payload: data })
  }

  const handleReadAnnouncement = (data: AnnouncementViewModel) => {
    dispatch({ type: 'ANNOUNCEMENT_PUT', payload: data })
  }

  const handleReadAllAnnouncements = () => {
    dispatch({ type: 'ALL_READ' })
  }

  const handleDeleteAnnouncement = (data: AnnouncementViewModel) => {
    dispatch({ type: 'ANNOUNCEMENT_DELETE', payload: data })
  }

  return children({ ...state, fetchAnnouncements, markRead })
}
